import DialogStackContext from './DialogStackContext'
import { useContext } from 'react'

export function useDialogs() {
  return useContext(DialogStackContext)
}
